import React from 'react';

export const AircraftIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M2 12h20" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 2v20" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 9c2 0 3 2 5 2s3-2 5-2 3 2 5 2" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement> & { rotated?: boolean }> = ({ rotated, ...props }) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={rotated ? 'rotate-180' : ''} {...props}>
    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const StatusIcon: React.FC<{ state?: string; className?: string }> = ({ state, className }) => {
  const s = (state || '').toLowerCase();
  if (s.includes('approved') || s === 'approved') {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (s.includes('reject') || s === 'rejected') {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (s.includes('sent') || s === 'sent') {
    return (
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
        <path d="M22 2L11 13" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" strokeWidth={0.8} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  // pending / default
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={1.2} />
      <path d="M12 7v6l3 2" stroke="currentColor" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default null;
